import { AUTH_REQUEST_TIMEOUT_MS } from './authRequestTimeout'
export const LOGIN_ATTEMPT_TIMEOUT_MS = AUTH_REQUEST_TIMEOUT_MS
const pendingPasswordAttempts = new WeakMap()
const timeoutError = () => Object.assign(new Error('Login attempt timed out.'), {code:'LOGIN_ATTEMPT_TIMEOUT'})

// Keep the completion separate from the UI deadline: if an SDK/storage lock
// outlives the deadline, callers must not submit a second password request.
export function startLoginAttempt(client, credentials, { timeoutMs = LOGIN_ATTEMPT_TIMEOUT_MS } = {}) {
  const previous = pendingPasswordAttempts.get(client)
  if (previous) return {
    result:Promise.reject(Object.assign(new Error('A previous sign-in request is still running.'), {code:'LOGIN_ATTEMPT_PENDING'})),
    completion:previous.completion,
  }
  const attempt = {}
  let expired = false
  let timer
  const completion = Promise.resolve().then(async () => {
    const {data,error} = await client.auth.signInWithPassword(credentials)
    if (error) throw error
    let session = data?.session
    if (!session?.user) {
      if (expired) throw timeoutError()
      const {data:sessionData,error:sessionError} = await client.auth.getSession()
      if (sessionError) throw sessionError
      session = sessionData?.session
    }
    if (!session?.user) throw Object.assign(new Error('Session could not be stored.'), {code:'LOGIN_SESSION_MISSING'})
    return session
  }).finally(() => {
    if (pendingPasswordAttempts.get(client) === attempt) pendingPasswordAttempts.delete(client)
  })
  attempt.completion = completion
  pendingPasswordAttempts.set(client,attempt)
  const deadline = new Promise((_,reject) => {timer=setTimeout(() => {expired=true;reject(timeoutError())},timeoutMs)})
  const result = Promise.race([completion,deadline]).finally(() => clearTimeout(timer))
  return {result,completion}
}

export function isLoginServiceError(error) {
  const status=Number(error?.status)
  return (status>=500 && status<=599) || ['LOGIN_ATTEMPT_TIMEOUT','AUTH_REQUEST_TIMEOUT'].includes(error?.code)
    || ['AuthRetryableFetchError','AuthRequestTimeoutError','AbortError','TypeError'].includes(error?.name)
    || /timed? out|failed to fetch|network|fetch failed|load failed/i.test(error?.message || '')
}
